// extracted by mini-css-extract-plugin
module.exports = {"container":"_3a-Qt","pimple":"_3lNNn","updatedIndicationText":"_2oYP4"};